module.exports = __webpack_public_path__ + "img/ltkholiday-1x.8dc2e58.jpg";